import axios, { AxiosResponse } from 'axios'
import { ID, Response } from 'src/_metronic/helpers'
import { configuration } from 'src/configuration'

const API_URL = configuration.apiUrl
// const DELETE_URL = configuration.deleteUrl
const Transactions_URL = `${API_URL}/message/transactions`
const Transactions_LISTING = `${API_URL}/message/v1/transactions`
const Delete_Transactions_URL = `${API_URL}/message/deleteTransaction`
const City_URL = `${API_URL}/cities`
const PARTY_URL = `${API_URL}/party/getPartyListing`
const USER_URL = `${API_URL}/users/allUser`

// const getTransactions = (query: string): Promise<any> => {
//   return axios.get(`${Transactions_URL}?${query}`).then((d: AxiosResponse<any>) => d.data)
// }
const getTransactions = (query: string): Promise<any> => {
  const params = new URLSearchParams(query);


  // Extract sort and order values
  const sort = params.get("sort");
  const order = params.get("order")?.toUpperCase();

  // Handle orderBy dynamically
  params.delete("sort");
  params.delete("order");
  if (sort && order) {
    params.set("orderBy", `${sort} ${order}`);
  }
  // Rename page → offset and perPage → limit
  const page = (params.get("page")) || 1;
  // const limit = params.get("perPage") ?? 10;
  const perPage = (params.get("perPage")) || 10;
  // const offset = (page - 1) * limit; // Adjust offset calculation

  params.set("page", page.toString());
  params.set("perPage", perPage.toString());

  // params.delete("page");
  // params.delete("perPage");
  return axios
    .get(`${Transactions_URL}?${params.toString()}`)
    .then((d: AxiosResponse<any>) => d.data);
}

const formatDate = (dateStr: string): string => {
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};

// _requests.ts
// _requests.ts
const getTransactionsListing = (query: string): Promise<any> => {
  const params = new URLSearchParams(query);

  let sort = params.get("sort");
  let order = params.get("order")?.toUpperCase();

  // Set default sorting if not provided
  if (!sort || !order) {
    sort = 'id'; // Default column
    order = 'ASC'; // Default order
  }

  params.delete("sort");
  params.delete("order");
  params.set("orderBy", `${sort} ${order}`);

  const page = params.get("page") || "1";
  const perPage = params.get("perPage") || "10";

  params.set("page", page);
  params.set("perPage", perPage);

  return axios
    .get(`${Transactions_LISTING}?${params.toString()}`)
    .then((response: AxiosResponse<any>) => {
      const data = response.data;

      // Format created_date in responseData array
      if (Array.isArray(data.responseData)) {
        data.responseData = data.responseData.map((item: any) => ({
          ...item,
          // created_at: formatDate(item.created_at),
        }));
      }

      return data;
    });
};

const getTransaction = (query: string): Promise<any> => {
  return axios
    .get(`${PARTY_URL}?is_active=true&sort=party_name&order=ASC`)
    .then((d: AxiosResponse<any>) => d.data)
}

const getUsers = (query: string): Promise<any> => {
  return axios.get(`${USER_URL}?sort=name&order=ASC`).then((d: AxiosResponse<any>) => d.data)
}
const uniqueCode = (query: string): Promise<any> => {
  return axios
    .get(`${Transactions_URL}/uniqueCode?party_code=${query}`)
    .then((d: AxiosResponse<any>) => d.data)
}
const getCities = (): Promise<any> => {
  return axios.get(`${City_URL}?sort=name&order=ASC`).then((d: AxiosResponse<any>) => d.data)
}
const getTransactionsById = (id: any): Promise<any> => {
  return axios
    .get(`${Transactions_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const createTransactions = (data: any): Promise<any> => {
  return axios
    .post(Transactions_URL, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const createCity = (data: any): Promise<any> => {
  return axios.post(City_URL, data).then((response: AxiosResponse<Response<any>>) => response.data)
}

const updateTransactions = (data: any, id: any): Promise<any> => {
  return axios
    .patch(`${Transactions_URL}/${id}`, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

// const deleteTransactions = async (id: any): Promise<any> => {
//   return axios
//     .delete(`${Delete_Transactions_URL}/${id}`)
//     .then((response: AxiosResponse<Response<any>>) => response.data)

// }
const deleteTransactions = async (id: any, data: any): Promise<any> => {
  return axios
    .delete(`${Delete_Transactions_URL}/${id}`, {
      data: data, // Pass data in the request body
    })
    .then((response: AxiosResponse<Response<any>>) => response.data);
};


// const deleteTransactions = async (id: any): Promise<any> => {
//   try {
//     console.log('Deleting transaction with ID:', id);
//     const response = await axios.delete(`${Delete_Transactions_URL}/${id}`);
//     console.log('Delete Response:', response);
//     return response;
//   } catch (error) {
//     console.error('Delete API Error:', error);
//     throw error; 
//   }
// };

const DeviceTokenReset = (id: any): Promise<any> => {
  return axios
    .delete(`${Transactions_URL}/deviceTokenReset/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const deleteSelectedTransactions = (TransactionsIds: Array<ID>): Promise<void> => {
  const requests = TransactionsIds.map((id) => axios.delete(`${Transactions_URL}/${id}`))
  return axios.all(requests).then(() => { })
}

const getParties = (): Promise<any> => {
  return axios
    .get(`${PARTY_URL}?is_active=true&sort=party_name&order=ASC`)
    .then((d: AxiosResponse<any>) => d.data)
}

export {
  createTransactions,
  deleteTransactions,
  deleteSelectedTransactions,
  getTransactionsById,
  getTransactions,
  updateTransactions,
  getTransaction,
  getTransactionsListing,
  createCity,
  getCities,
  DeviceTokenReset,
  uniqueCode,
  getUsers,
  getParties
}
